module.exports = __webpack_public_path__ + "img/real_name_ok.d4e1aca6.png";